// extracted by mini-css-extract-plugin
export default {"title":"PopupCreateTask_title__BYvT-","action":"PopupCreateTask_action__QeqJo","modules":"PopupCreateTask_modules__KtIRa"};